import axiosInstance, {
  getUserDetails,
  getStaffId,
  isFisherWideUser,
  isIndependentScientistUser,
} from "../components/content/axiosConfig";

const RESULT_LIMIT = 8;

function unwrapList(body) {
  if (Array.isArray(body)) return body;
  return body?.data || [];
}

function canSearchStaff(user) {
  if (isIndependentScientistUser(user)) return false;
  if (!isFisherWideUser(user)) return false;
  const fisherID = user?.FisherID;
  return fisherID != null && fisherID !== "" && !Number.isNaN(Number(fisherID));
}

export async function fetchGlobalSearchResults(query) {
  const term = String(query || "").trim();
  if (term.length < 2) {
    return { ponds: [], pondDetails: [], staff: [] };
  }

  const user = getUserDetails();
  const staffId = getStaffId(user);
  const fisherID = user?.FisherID;
  const fisherWide = isFisherWideUser(user);
  const independent = isIndependentScientistUser(user);
  const skipFisherScope = independent || fisherID == null || fisherID === "";

  if (!staffId) {
    return { ponds: [], pondDetails: [], staff: [] };
  }

  const params = { search: term, page: 1, limit: RESULT_LIMIT };
  const requests = [];

  if (fisherWide && fisherID) {
    requests.push(
      axiosInstance
        .get(`api/Pond/GetAllPond/${fisherID}`, { params })
        .then((res) => ({ type: "ponds", data: unwrapList(res.data) }))
        .catch(() => ({ type: "ponds", data: [] }))
    );
    requests.push(
      axiosInstance
        .get(`/api/PondDetail/GetAllDetails/${fisherID}`, { params })
        .then((res) => ({ type: "pondDetails", data: unwrapList(res.data) }))
        .catch(() => ({ type: "pondDetails", data: [] }))
    );
  } else {
    const staffParams = { ...params };
    if (!skipFisherScope && fisherID) {
      staffParams.fisherID = fisherID;
    }
    requests.push(
      axiosInstance
        .get(`api/Pond/GetAllPondsByStaff/${staffId}`, { params: staffParams })
        .then((res) => ({ type: "ponds", data: unwrapList(res.data) }))
        .catch(() => ({ type: "ponds", data: [] }))
    );
    requests.push(
      axiosInstance
        .get(`/api/PondDetail/GetPondDetailsByStaff/${staffId}`, { params: staffParams })
        .then((res) => ({ type: "pondDetails", data: unwrapList(res.data) }))
        .catch(() => ({ type: "pondDetails", data: [] }))
    );
  }

  if (canSearchStaff(user)) {
    requests.push(
      axiosInstance
        .get(`api/User/GetAllStaff/${fisherID}`, { params })
        .then((res) => ({ type: "staff", data: unwrapList(res.data) }))
        .catch(() => ({ type: "staff", data: [] }))
    );
  }

  const settled = await Promise.all(requests);
  const result = { ponds: [], pondDetails: [], staff: [] };
  for (const item of settled) {
    if (item.type === "ponds") result.ponds = item.data;
    if (item.type === "pondDetails") result.pondDetails = item.data;
    if (item.type === "staff") result.staff = item.data;
  }
  return result;
}
